import React, { FC } from 'react';

import { Label } from '@smartshell/ui-kit';
import cn from 'classnames';

import { EBeneficiaryStatus, IBeneficiaryCard } from '../../interfaces';
import Body from './Body';
import s from './CompanyCard.module.scss';

export const BeneficiaryCard: FC<IBeneficiaryCard> = ({
  onClick,
  beneficiary,
  checkedBeneficiary,
}) => {
  return (
    <div
      className={cn(
        s.beneficiary,
        onClick && s.beneficiary_check,
        checkedBeneficiary === beneficiary.id && s.active
      )}
      onClick={onClick}
    >
      <Body beneficiary={beneficiary} />
      {beneficiary.status === EBeneficiaryStatus.APPROVED && (
        <Label
          size="s"
          color="green"
          iconName="SuccessIcon"
          text="Проверка пройдена"
        />
      )}
      {beneficiary.status === EBeneficiaryStatus.PENDING && (
        <Label
          size="s"
          color="orange"
          iconName="ClockIcon"
          text="Проверяется"
        />
      )}
      {beneficiary.status === EBeneficiaryStatus.ERROR && (
        <Label
          size="s"
          color="red"
          iconName="CircleCloseIcon"
          text="Отклонено"
        />
      )}
    </div>
  );
};

export default BeneficiaryCard;
